import Mock from 'mockjs';
import loginAPI from './login';


// 登录相关
/*Mock.mock(/\/login\/loginbypwd/, 'post', loginAPI.loginByEmail);
Mock.mock(/\/login\/logout/, 'post', loginAPI.logout);
Mock.mock(/\/manage\/user\/info\.*!/, 'get', loginAPI.getInfo);*/


 export default Mock;



// WEBPACK FOOTER //
// ./src/mock/index.js